import React from 'react';

const PostAgeTag = ({ age }) => {
  return <div className={'bg-age-tag p-1 rounded'}>{age} y.o</div>;
};

export default PostAgeTag;
